export const DEFAULT_PAGE_SIZE = 12;
export const DEFAULT_PAGE_LIMIT = 50;
export const DEFAULT_PAGE = 1;
